import styled from 'styled-components';
import { GatsbyImage } from "gatsby-plugin-image";

export const CarouselContainer = styled.div`
    display: flex;
    width: 100%;
    height: 500px;
    color: white;
    border-radius: 50px;
    margin: 35px 0px;
    position: relative;
    @media only screen and (max-width: 885px) {
        height: 100vh;
    }
`;

export const BlogTextContainer = styled.div`
    white-space: break-spaces;
    height: 100%;
    color: black;
    width: 44%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: 0px 20px 0px 50px;
    @media only screen and (max-width: 885px) {
        width: 100%;
        padding: 0px;
        align-items: center;
        text-align: center;
        height: 70vh;
    }
`;
export const StyledGatsbyImage = styled(GatsbyImage)`
    width: 50%;
    height: 100%;
    padding: 20px 0px;
    @media only screen and (max-width: 885px) {
        width: 100%;
        padding: 0px;
        height: 30vh;
    }
`;

export const StyledBlogPostContainer = styled.a`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-contetnt: center;
    padding-bottom: 40px;
    text-decoration: none;
    cursor: pointer;
    :hover {
        text-decoration: none;
    }
    @media only screen and (max-width: 885px) {
        margin-top: 20px;
        flex-direction: column;
    }
`;

export const BolgTextHeader = styled.h3`
    @media only screen and (max-width: 885px) {
        font-size: 1.5rem;
    }
`;
